<template>
  <div class="validation-token">
    <div class="validation-token__wrapper">
      <div
        class="validation-token__content"
        :class="{ 'validation-token__content--visible': isIconResultVisible }"
      >
        <VSpinnerIconLoader v-if="!haveResponse" :loaderOptions="iconResultMessageData" />
      </div>
    </div>
  </div>
</template>

<script>
import VSpinnerIconLoader from '@/components/commons/VSpinnerIconLoader';

export default {
  name: 'ValidationLoading',
  components: {
    VSpinnerIconLoader,
  },
  data: () => ({
    iconResultMessageData: {
      mainLoaderMessage: 'Validando token...',
      iconSvgName: 'amilIcon',
    },
    isIconResultVisible: false,
    haveResponse: false,
  }),
  async created() {
    this.showIconResult();

    setTimeout(async() => {
      this.haveResponse = true;
      return this.goNextStep('validation_response');
    }, 8000);
  },
  methods: {
    showIconResult() {
      setTimeout(() => {
        this.isIconResultVisible = true;
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.validation-token {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 24px);
  justify-content: center;
  position: relative;
  width: 100%;

  &__wrapper {
    height: 510px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  &__content {
    align-items: center;
    display: flex;
    flex-direction: column;
    opacity: 0;
    padding: 0 10px 0;
    position: relative;
    transition: opacity 1s ease-in;
    z-index: 0;
    max-width: 240px !important;

    &--visible {
      opacity: 1;
    }
  }
}
</style>
